import { fetchGet, fetch } from "@/utils/request";

export default {
  //获取场站名称和区域信息（运营商管理中使用）
  getStationList() {
    return fetchGet("/elecStation/getStationList");
  },

  // 获取场站位置信息（可用于模糊搜索）
  getStationPosition(param) {
    return fetchGet("/elecStation/getAllList", param);
  },
  //获取最新信息
  getLatestStationInfo(param) {
    return fetchGet("/elecCheckList/getCheckList", param);
  },
  addCheckInfo(param) {
    return fetch("/elecCheckList/addCheckList", param);
  },
  //上传巡查信息
  upCheckInfo(param) {
    return fetch("/upload/uploadStationCheck", param);
  },
  //下载文件
  downloadFile(param) {
    return fetchGet("/down/downloadStationCheck", param);
  },
};
